
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface RepsFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export const RepsField = ({ value, onChange }: RepsFieldProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm text-gray-200">
        Repeticiones
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="h-10 border-primary/30 hover:border-primary/50 transition-all duration-200 text-white bg-white/10">
          <SelectValue placeholder="Reps" />
        </SelectTrigger>
        <SelectContent className="bg-[black]/20 border-primary/30 z-[100]">
          {Array.from({ length: 21 }, (_, i) => (
            <SelectItem 
              key={i} 
              value={i.toString()}
              className="text-white hover:text-white hover:bg-primary/20 focus:bg-primary/30"
            >
              {i} {i === 1 ? 'rep' : 'reps'}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
